<template>
  <div>
    <div class="text-center mt-2" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="base-card pa-5">
            <div class="d-flex">
              <v-btn
                :disabled="isAllProtocolsWithId"
                :loading="loading"
                small
                color="primary"
                class="white--text px-4"
                @click="fillProtocolsByCycleId"
              >
                <v-icon left small>mdi-text-box-outline</v-icon>Данные о протоколах
              </v-btn>
            </div>
          </v-card>

          <ProtocolTable
            :infoBlockHeight="infoBlockHeight"
            :protocols="protocols"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { protocolApi } from '@/api'
import { mapGetters } from 'vuex'
import ProtocolTable from '@/components/cycles/cycle/protocol/Table'
import { formatDateToISO } from '@/scripts'

export default {
  name: 'Protocols',

  metaInfo: {
    title: 'Протоколы'
  },

  components: {
    ProtocolTable
  },

  props: {
    infoBlockHeight: Number
  },

  async created() {
    await this.getFinalAttestationProtocols()

    this.dataLoaded = true
  },

  mounted() {
    this.hideHtmlOverflow()
  },

  destroyed() {
    this.showHtmlOverflow()
  },

  data: () => ({
    dataLoaded: false,
    loading: false,
    protocols: []
  }),

  computed: {
    ...mapGetters('cycle', ['cycleId', 'fromDate', 'toDate']),

    isAllProtocolsWithId() {
      return this.protocols.every(el => el.protocolId)
    }
  },

  methods: {
    async getFinalAttestationProtocols() {
      try {
        const data = await protocolApi.getFinalAttestationProtocols(this.cycleId)
        if (data.length) this.protocols = data
      } catch (e) {
        console.log(e.status)
      }
    },

    async fillProtocolsByCycleId() {
      try {
        this.loading = true

        await protocolApi.fillProtocolsByCycleId(this.cycleId)
        await this.getFinalAttestationProtocols()
      } catch (e) {
        console.log(e.status)
      } finally {
        this.loading = false
      }
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.setProperty('overflow-y', 'hidden', 'important')
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    }
  }
}
</script>